import * as React from 'react';
import {FunctionComponent} from 'react';
import {observer} from 'mobx-react-lite';
import {FullCrew} from '../../../../../Models/Crew';
import {PresenterProps, withPresenter} from '../../../../../Support/with_presenter';
import {CrewWorkoutsPresenter} from './CrewWorkoutsPresenter';
import {UpcomingEvents} from '../../../../Components/Crew/UpcomingEvents';
import {ThisWeek} from './Internal/ThisWeek';
import {CrewActivities} from './Internal/CrewActivities';
import {FeatureFlags} from '../../../../../FeatureFlags';
import {CrewActivitiesPromo} from './Internal/CrewActivitiesPromo';

interface OwnProps {
    crew: FullCrew;
}

const CrewWorkoutsComponent: FunctionComponent<OwnProps & PresenterProps<CrewWorkoutsPresenter>> = observer(
    ({crew}) => {
        return (
            <>
                <div className="row">
                    <div className="col-12">
                        <h3>Overview</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <UpcomingEvents className="mb-3" placeholder crewScopes={[crew]} />
                    </div>
                    <div className="col-12 col-md-6">
                        <ThisWeek className="mb-3" crew={crew} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <h3>Activity</h3>
                    </div>
                </div>
                {FeatureFlags.crewActivity && (!FeatureFlags.isAdvancedSubscriptionsEnabled || crew.isAdvanced) ? (
                    <CrewActivities crew={crew} />
                ) : (
                    <CrewActivitiesPromo crew={crew} />
                )}
            </>
        );
    },
);

export const CrewWorkouts = withPresenter<CrewWorkoutsPresenter, OwnProps>(
    (props, component) => new CrewWorkoutsPresenter(),
    CrewWorkoutsComponent,
);
